// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useMemo, useRef,
  useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../../hola/pub/settings_ctx';
import {statuses} from '../../../../../hola/pub/data_ctx';
import etask from 'zetask';
import {use_data_provider} from '../../../../../hola/pub/lib/use_data_provider';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {get_article_date,
    i_article_result, i_category} from '../../../../../hola/pub/ui/blog/i_blog';
import {Link, useHistory} from 'react-router-dom';
// @ts-ignore
import {perr_www_visit} from '/www/hola/pub/util.js';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';
import {Spacer} from '../../../../../hola/pub/ui/homepage/spacer';
import {use_article_links} from '../../../ui/blog/use_article_links';
import Icon_facebook from '../../../../../hola/pub/img/hola2023/icons/32/facebook_icon.svg';
import Icon_twitter from '../../../../../hola/pub/img/hola2023/icons/32/twitter_icon.svg';
import Icon_linkedin from '../../../../../hola/pub/img/hola2023/icons/32/linkedin_icon.svg';
import Icon_copy from '../../../../../hola/pub/img/hola2023/icons/32/copy_icon.svg';
import Icon_chevron_left from '../../../../../hola/pub/img/hola2023/icons/16/chevron_left.svg';
import {Article_card} from '../../../ui/blog/article_card';
import styles from './article.module.less';
import {Button} from '../../../../../hola/pub/lib/button';
import {Scroll_index} from '../../../ui/blog/scroll_index';
import {use_screen} from '../../../../../hola/pub/lib/screen_util';

const get_data_id = params=>`/blog/page/${params.page}/category/`+
    `${params.category}/per_page/${params.per_page||9}/slug/${params.slug}`;

const Author = ({art})=>{
    const {theme} = useContext(Settings_context);
    const author = art?.data?.author;
    const author_img_url = author?.img?.url || '';
    return author ? <div className={styles.author}>
      {author_img_url && <div className={styles.author_pic}
        style={{backgroundImage: `url(${author_img_url})`}} />}
      <p className={cn(theme.color_n400, theme.u2, theme.med)}>
        {author.name || 'Unknown Author'}<br/>
        {author.position || ''}
      </p> </div>
    : null;
};

const Share = ({art})=>{
    const {facebook_link, twitter_link, linkedin_link,
        copy} = use_article_links({
        article_id: art.data.id,
        article_title: art.data.title,
    });
    const on_copy_link = ev=>{
        ev.preventDefault();
        copy();
    };
    return <div className={styles.share}>
      <a href={twitter_link}><Icon_twitter/></a>
      <a href={facebook_link}><Icon_facebook/></a>
      <a href={linkedin_link}><Icon_linkedin/></a>
      <a href="#" onClick={on_copy_link}><Icon_copy/></a>
    </div>;
};

const Back_btn = ({cat}: {cat?: i_category})=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    return <button className={styles.back_btn} onClick={()=>{
      if (history.length > 2)
        return void history.goBack();
      if (cat)
        return void history.replace(`/blog/${cat.slug}`);
      history.replace('/blog');
    }}>
      <Icon_chevron_left className={theme.color_n300}/>
       <span className={cn(theme.P, theme.p2, theme.med, theme.color_n300)}>
        Back</span>
    </button>;
};

export const Root = ()=>{
    const {theme} = useContext(Settings_context);
    // @ts-ignore
    const {user} = useContext(App_context);
    const {data} = use_data_provider(get_data_id);
    const [art, set_art_result] = useState(data.result as i_article_result);
    const visited = useMemo(()=>({}), []);
    const {width} = use_screen();
    const header_refs = useMemo(()=>({}), []);
    const observer_ref = useRef(null);
    const [extracted_headers, set_extracted_headers] = useState([]);
    const [active_header_id, set_active_header_id] = useState(null);
    const on_intersect = entries=>{
    const changed = entries.reduce((acc, entry)=>{
        acc[entry.target.id] = entry.isIntersecting;
        return acc;
    }, {});
    const first_visible = Object.keys(changed).find(id=>changed[id]);
    if (first_visible)
        set_active_header_id(first_visible);
    };
    useEffect(()=>{
        if (data && data.status == statuses.done)
        {
            set_art_result(data.result);
            if (data.result.data && !visited[data.result.data.id])
            {
                visited[data.result.data.id] = true;
                perr_www_visit({
                    id: `www_blog_article_${data.result.data.id}_visit`,
                    user,
                });
                fetch(`/cms_api/blog/read_post?id=${data.result.data.id}`);
            }
        }
    }, [data]);
    useEffect(()=>{
        if (art && !art.error)
        {
            const article_body =
                document.querySelector(`.${styles.article_body}`);
            if (article_body)
            {
                const header_elements =
                    article_body.querySelectorAll('h1, h2, h3, h4');
                const headers = Array.from(header_elements).map((el, index)=>{
                    const id = el.id || `header-${index}`;
                    el.id = id;
                    header_refs[id] = {current: el};
                    return {
                        id: id,
                        text: el.textContent || '',
                        level: parseInt(el.tagName[1]),
                    };
                });
                set_extracted_headers(headers);
            }
        }
    }, [art]);
    useEffect(()=>{
        if (extracted_headers.length && 'IntersectionObserver' in window)
        {
            observer_ref.current = new IntersectionObserver(on_intersect, {
                threshold: [0, 1],
                rootMargin: '-10% 0px -70% 0px'
            });
            extracted_headers.forEach(header=>{
                const element = header_refs[header.id].current;
                if (element)
                    observer_ref.current.observe(element);
            });
        }
        return ()=>{
            if (observer_ref.current)
            {
                observer_ref.current.disconnect();
                observer_ref.current = null;
            }
        };
    }, [extracted_headers]);
    const scroll_to_header = header_id=>{
        const element = document.getElementById(header_id);
        if (element)
        {
            const offset = 120;
            const element_position = element.getBoundingClientRect().top;
            const offset_position = element_position + window.scrollY - offset;
            window.scrollTo({top: offset_position, behavior: 'smooth'});
        }
    };
    return <div className={cn(theme.root, styles.root)}>
      <div className={cn(theme.container, styles.article_container)}>
        <div className={styles.article_content}>
          <div className={styles.article}>
            {art && !art.error && <div className={styles.article_header}>
              <Back_btn cat={art?.data?.categories[0]}/>
              <p className={cn(theme.p2, theme.med, theme.color_n300,
                styles.breadcrumbs)}>
                {art && !art.error && art.data.categories[0] &&
                  <Link className={cn(styles.link, theme.color_n300)}
                  to={`/blog/${art.data.categories[0].slug}`}>
                  {art.data.categories[0].name}</Link>}
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"
                  viewBox="0 0 4 4" fill="none">
                  <circle cx="2" cy="2" r="2" fill="#ABABAB"/>
                </svg>
                {art.data.time_to_read} read
              </p>
              <p className={cn(theme.u2, theme.med, styles.date)}>
                {get_article_date(art.data)}
              </p>
              <h1 className={cn(theme.H3, styles.title)}
                dangerouslySetInnerHTML={{__html: art.data.title}}/>
            </div>}
            {art && !art.error ? <Fragment>
              {art.data.img && <div className={styles.img_art}>
                <img src={art.data.img}/>
              </div>}
              <div className={styles.after_img}>
                <Author art={art}/>
                <Share art={art}/>
              </div>
              <div className={styles.article_body}
                dangerouslySetInnerHTML={{__html: art.data.content}}></div>
              {/* <div className={styles.after_article}>
                  <Share art={art}/>
              </div> */}
            </Fragment> : <span>{art && art.error}</span>}
          </div>
          </div>
          {width>950 &&
            <div className={styles.scrollable_index_container}>
              <div className={styles.scrollable_index}>
                <Scroll_index
                  headers={extracted_headers}
                  active_header_id={active_header_id}
                  on_header_click={scroll_to_header}
                />
              </div>
            </div>
          }
    </div>
    <div className={styles.banner}>
      <div className={cn(styles.png_container, theme.container)}>
        <div className={styles.content_block}>
          <h4 className={cn(theme.color_n700)}>
            Access Worldwide Data</h4>
          <p className={cn(styles.banner_content, theme.p2, theme.reg,
            theme.color_n400)}>
            Toolip proxies and datacenters open up the global internet
            for you, getting you the competitive edge needed to achieve
            your goals!</p>
          <Button caption={'Get started'} to='/pricing' color='black'
            width={139}/>
        </div>
      </div>
    </div>
    <Spacer/>
    {data.result && <div className={theme.container}>
      <div className={styles.recent}>
        <h3 className={cn(theme.reg, theme.H5, styles.recent_title)}>
          You might like these, too
        </h3>
        <div className={styles.recent_list}>
          {data.result.recent_posts?.map(p=>{
              return <Article_card key={p.id} {...p}/>;
          })}
        </div>
      </div>
    </div>}
    <Spacer/>
    <Spacer/>
  </div>;
};

Root.meta = {
    ssr_force: true,
    nosearch: true,
    meta: props=>{
      if (props.data_from_provider)
      {
          const seo_data = props.data_from_provider[0]?.data.seo;
          const seo_title = seo_data?.title ||
              props.data_from_provider[0]?.data.title;
          const seo_keywords = seo_data?.keywords || '';
          const seo_date = props.data_from_provider[0]?.data.datetime?.date;
          const new_title = `${seo_title} - Toolip Proxies Blog`;
          const new_description = `Get insights into ${seo_title} and its 
              top features.`;
          const category_slug =
              props.data_from_provider[0]?.data.categories?.[0]?.slug
              || 'market-research';
          const article_slug = props.data_from_provider[0]?.data.slug;
          const canonical_url = category_slug
                ? `https://toolip.io/blog/${category_slug}/${article_slug}`
                : `https://toolip.io/blog/${article_slug}`;
          return {
              title: new_title,
              description: new_description,
              canonical_url,
              og_title: new_title,
              og_description: new_description,
              keywords: seo_keywords,
              og_url: canonical_url,
              og_image: props.data_from_provider[0]?.data.img,
              author: props.data_from_provider[0]?.data.author?.name,
              published_time: seo_date && new Date(seo_date).toISOString(),
          };
      }
      return {
          title: 'Toolip Proxies Blog',
          canonical_url: 'https://toolip.io/blog/article/slug/',
      };
  },
    set_data_cache: (data_cache, params, data)=>{
      const cache_key = `/blog/page/${params.page}/category/`+
          `${params.category}/per_page/${params.per_page||9}`+
          `/slug/${params.slug}`;
      data_cache[cache_key] = data;
    },
    get_data_id,
    data_provider: (data_cache, params)=>etask(function*(){
      const cache_key = `/blog/page/${params.page}/category/`+
            `${params.category}/per_page/${params.per_page||9}/`+
            `slug/${params.slug}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        if (!params.id && !params.slug)
            return {data: {}, error: 'article id should be specified'};
        const data = yield fetch(`https://toolip.io/cms_api/blog/post/`+
            `?slug=${params.slug}&id=${params.id}`);
        if (!data || data.indexOf && data.indexOf('<!DOCTYPE')>-1)
            return {data: {}, error: 'not found'};
        const end = `https://toolip.io/cms_api/blog/posts`;
        let recent_posts = yield fetch(`${end}?posts_per_page=3&paged=0`);
        if (typeof recent_posts!='object')
            recent_posts = {};
        recent_posts = recent_posts.posts||[];

        const result = {
            data,
            recent_posts,
            error: '',
            cache_key,
        };

        data_cache[cache_key] = result;
        return result;
    }),
    default_theme: 'toolip',
};
